// prettier-ignore
export default "tr"